import { useState, useEffect, useCallback } from "react";

const HISTORY_KEY = "louve_hino_history";
const MAX_HISTORY = 10;

export interface HinoHistoryItem {
  id: string;
  titulo: string;
  numero: number;
  timestamp: number;
}

export const useHinoHistory = () => {
  const [history, setHistory] = useState<HinoHistoryItem[]>([]);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(HISTORY_KEY);
      if (stored) setHistory(JSON.parse(stored));
    } catch {}
  }, []);

  const addToHistory = useCallback((item: Omit<HinoHistoryItem, "timestamp">) => {
    setHistory((prev) => {
      const filtered = prev.filter((h) => h.id !== item.id);
      const updated = [{ ...item, timestamp: Date.now() }, ...filtered].slice(0, MAX_HISTORY);
      localStorage.setItem(HISTORY_KEY, JSON.stringify(updated));
      return updated;
    });
  }, []);

  const clearHistory = useCallback(() => {
    localStorage.removeItem(HISTORY_KEY);
    setHistory([]);
  }, []);

  return { history, addToHistory, clearHistory };
};
